import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { Part } from 'projects/cart-tv/src/app/data/parts/part';

@JsonObject('model.PartGroup')
export class PartGroup extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty([Part], 'parts')
  parts?: Part[];

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(Number, 'area')
  area: number;

  @JsonProperty(String, 'notes')
  notes: string;
}
